import { Injectable } from '@angular/core';
import { TunaPiece } from '../interfaces/tuna-piece';
import {
  AngularFireDatabase,
  AngularFireList,
  AngularFireObject,
} from '@angular/fire/compat/database';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TunaPieceCrudService {

  refs: AngularFireList<any> | undefined;
  ref: AngularFireObject<any> | undefined;

  path: string;

  constructor(private db: AngularFireDatabase) {
    this.path = environment.name + '/tunaPieces/' ;
  }

  // Create TunaPiece
  add(record: TunaPiece) {
    this.refs = this.db.list( this.path );
    const item = {
      ...record
    }
    this.refs?.push( item );
  }
  // Fetch Single TunaPiece Object
  get(id: string) {
    this.ref = this.db.object( this.path + id);
    return this.ref;
  }
  // Fetch TunaPieces List
  getList() {
    this.refs = this.db.list( this.path );
    return this.refs;
  }
  // Update TunaPiece Object
  update(record: TunaPiece) {
    this.ref = this.db.object( this.path + record.$key);
   // console.log("P inside", record);
    let item : Partial<TunaPiece>  = {
      ...record
    }
    delete item?.$key;
    this.ref?.update(item);
  }
  // Delete TunaPiece Object
  delete(id: string) {
    this.ref = this.db.object( this.path + id);
    this.ref.remove();
  }
}
